import React, { useEffect, useRef, useState } from "react";
import "./CardItem.scss";
import LazyImage from "../../../LazyImage/LazyImage";
import Button from "../../../Button/Button";

export default function CardItem({
  title,
  description,
  image,
  buttonHref,
  buttonText,
  reverse,
}) {
  const images = Array.isArray(image) ? image : [image];
  const [isCurrent, setIsCurrent] = useState(0);
  const intervalRef = useRef(null);
  const sliderRef = useRef();

  const clearAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startAutoplay = () => {
    clearAutoplay();
    intervalRef.current = setInterval(() => {
      setIsCurrent((prev) => (prev + 1) % images.length);
    }, 8000);
  };

  const pauseAutoplay = () => {
    clearAutoplay();
  };

  const resetAutoplay = () => {
    clearAutoplay();
    startAutoplay();
  };

  const handlePrev = () => {
    setIsCurrent((prev) => (prev - 1 + images.length) % images.length);
    resetAutoplay();
  };

  const handleNext = () => {
    setIsCurrent((prev) => (prev + 1) % images.length);
    resetAutoplay();
  };

  useEffect(() => {
    startAutoplay();
    return () => clearAutoplay();
  }, []);

  return (
    <div className={`card-item ${reverse ? "reverse" : ""}`}>
      <div className="card-item__content">
        <h1>{title}</h1>
        <p>{description}</p>
        <Button
          to={buttonHref}
          text={buttonText}
          variant={reverse ? "secondary" : "primary"}
        />
      </div>
      <div
        className="card-item__image"
        ref={sliderRef}
        onMouseEnter={() => pauseAutoplay()}
        onMouseLeave={() => startAutoplay()}
      >
        {images.length > 1 ? (
          <div className="slider">
            {images.map((image, index) => (
              <LazyImage
                src={image}
                key={index}
                className={`slider-image ${
                  index === isCurrent ? "active" : ""
                }`}
              />
            ))}
            <button className="slider-button left" onClick={handlePrev}>
              &lt;
            </button>
            <button className="slider-button right" onClick={handleNext}>
              &gt;
            </button>
          </div>
        ) : (
          <LazyImage src={images[0]} alt={title} className="slider-image" />
        )}
      </div>
    </div>
  );
}
